import {
	ROUTES_LOADING,
	ROUTES_GET,
	ROUTES_ERROR,
	ROUTE_DATA_LOADING,
	ROUTE_DATA_GET,
	ROUTE_DATA_ERROR,
	ROUTE_LOCATIONS_LOADING,
	ROUTE_LOCATIONS_GET,
	ROUTE_LOCATIONS_ERROR,
	ROUTE_CYCLE_GET,
	ROUTE_CYCLE_ERROR,
	SEARCH_ROUTES_UPDATES,
	SEARCH_ROUTES_UPDATES_ERROR,
	SEARCH_ROUTES_MINIS_LOADING,
	SEARCH_ROUTES_MINIS,
	SEARCH_ROUTES_MINIS_ERROR
} from '../types';

const initialState = {
	routes_loading: false,
	routes: { count: 0, routes: [] },
	route_data_loading: false,
	route_data: {},
	route_locations_loading: false,
	route_locations: {},
	route_cycle: {},
	routes_updates: [],
	routes_minis_loading: false,
	routes_minis: [],
	routes_errors: {}
}

export default function routesReducer(state = initialState, action){
	switch(action.type){
		case ROUTES_LOADING:
			return {
				...state,
				routes_loading: action.payload
			}
		case ROUTES_GET:
			return {
				...state,
				routes: {
					count: action.payload.count,
					routes: action.payload.routes
				}
			}
		case ROUTE_DATA_LOADING:
			return {
				...state,
				route_data_loading: action.payload
			}
		case ROUTE_DATA_GET:
			return {
				...state,
				route_data: action.payload
			}
		case ROUTE_LOCATIONS_LOADING:
			return {
				...state,
				route_locations_loading: true
			}
		case ROUTE_LOCATIONS_GET:
			return {
				...state,
				route_locations_loading: false,
				route_locations: action.payload
			}
		case ROUTE_CYCLE_GET:
			return {
				...state,
				route_cycle: action.payload
			}
		case SEARCH_ROUTES_UPDATES:
			return {
				...state,
				routes_updates: action.payload
			}
		case SEARCH_ROUTES_MINIS_LOADING:
			return {
				...state,
				routes_minis_loading: action.payload
			}
		case SEARCH_ROUTES_MINIS:
			return {
				...state,
				routes_minis: action.payload
			}
		case ROUTES_ERROR:
		case ROUTE_LOCATIONS_ERROR:
		case ROUTE_CYCLE_ERROR:
		case ROUTE_DATA_ERROR:
		case SEARCH_ROUTES_UPDATES_ERROR:
		case SEARCH_ROUTES_MINIS_ERROR:
			return {
				...state,
				route_locations_loading: false,
				routes_errors: {
					...state.routes_errors, 
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
